import type { Contact, Conversation } from '@/types'

export function normalizeComparablePhone(value?: string | null): string {
  const digits = (value ?? '').replace(/\D/g, '')
  if (digits.startsWith('55') && digits.length === 12) {
    const subscriber = digits.slice(4)
    if (subscriber.length === 8 && ['6', '7', '8', '9'].includes(subscriber[0] ?? '')) {
      return `${digits.slice(0, 4)}9${subscriber}`
    }
  }
  return digits
}

export function normalizeComparableJid(jid?: string | null): string {
  if (!jid) return ''
  const [local, domain = ''] = jid.trim().toLowerCase().split('@')
  const normalizedLocal = normalizeComparablePhone(local)
  if (domain === 'c.us' || domain === 's.whatsapp.net') {
    return normalizedLocal ? `${normalizedLocal}@s.whatsapp.net` : ''
  }
  return local ? `${local}@${domain}` : ''
}

export function getContactIdentityKey(contact: Partial<Contact>): string {
  const normalizedPhone =
    normalizeComparablePhone(contact.phone_number) ||
    normalizeComparablePhone(contact.jid?.split('@', 1)[0])

  if (contact.instance_id && normalizedPhone) {
    return `${contact.instance_id}:${normalizedPhone}`
  }

  return contact.id ?? contact.jid ?? ''
}

export function getConversationIdentityKey(conversation: Partial<Conversation>): string {
  const normalizedPhone =
    normalizeComparablePhone(conversation.contact?.phone_number) ||
    normalizeComparablePhone(conversation.contact?.jid?.split('@', 1)[0])

  if (conversation.instance_id && normalizedPhone) {
    return `${conversation.instance_id}:${normalizedPhone}`
  }

  if (conversation.instance_id && conversation.contact_id) {
    return `${conversation.instance_id}:contact:${conversation.contact_id}`
  }

  return conversation.id ?? ''
}
